import React from 'react';
import { useDragLayer } from 'react-dnd';

const CustomDragLayer = () => {
    const { isDragging, item, currentOffset } = useDragLayer((monitor) => ({
        itemType: monitor.getItemType(),
        isDragging: monitor.isDragging(),
        item: monitor.getItem(),
        currentOffset: monitor.getClientOffset(), // Get current mouse position
    }));

    if (!isDragging || !currentOffset) {
        return null; // Don't render anything if not dragging or if the offset is null
    }

    const style = {
        position: 'fixed',
        pointerEvents: 'none',
        left: currentOffset.x,
        top: currentOffset.y,
        opacity: 1, // Adjust the opacity of the drag preview here
        width: '48%'
    };

    return (
        <div style={style}>
            {/* Customize the drag preview appearance */}
            <div style={{margin: '0', opacity: 1, backgroundColor: "white"}}>
                {item && item.item && item.item.content} {/* Render the dragged item content */}
            </div>
        </div>
    );
};

export default CustomDragLayer;
